import { View } from 'backbone.marionette';
import { redirectTo } from '../../../../applications/NRL_Fantasy/utils';

class PasswordChangeConfirmationView extends View {
	events() {
		return {
			'click @ui.continue_linking_account': 'onClickContinueLinkingAccount'
		};
	}

	get className() {
		return "onboarding-form onboarding-change-old-account-password-confirmation";
	}

	ui() {
		return {
			continue_linking_account: '.js-continue-linking-account'
		};
	}

	initialize() {
	}

	onClickContinueLinkingAccount() {
		redirectTo('/onboarding');
	}
}

export default PasswordChangeConfirmationView;